import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FiX } from "react-icons/fi";
import "./Portfolio.css";
import { drawerVariants } from "../../animations";

const ProjectDrawer = ({ isOpen, onClose, project }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <div className="drawer__backdrop" onClick={onClose} />

          {/* Drawer */}
          <motion.aside
            className="drawer"
            variants={drawerVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            transition={{ type: "spring", stiffness: 260, damping: 30 }}
          >
            <button className="drawer__close icon-btn" onClick={onClose}>
              <FiX size={22} />
            </button>
            <div className="drawer__content" data-lenis-prevent>
              <h2>{project.title}</h2>

              {/* Technologies */}
              <div className="drawer__section">
                <h4>Technologies Used</h4>
                <ul>
                  {project.technologies.map((tech, index) => (
                    <li key={index}>{tech}</li>
                  ))}
                </ul>
              </div>

              {/* Platforms */}
              <div className="drawer__section">
                <h4>Platforms</h4>
                <ul>
                  {project.platforms.map((platform, index) => (
                    <li key={index}>{platform}</li>
                  ))}
                </ul>
              </div>

              {/* Description */}
              <div className="drawer__section">
                <h4>Detailed Description</h4>
                <p>{project.description}</p>
              </div>

              {/* Contribution */}
              <div className="drawer__section">
                <h4>My Contribution</h4>
                <ul>
                  {project.contribution.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
};

export default ProjectDrawer;
